import { ReactNode } from 'react'

interface AnalyticsProviderProps {
  children: ReactNode
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  // TODO: Implement analytics using @2cmstudio/analytics
  return <>{children}</>
}